import darkPlateBackground from '../../list-plate-background/dark';

const dark = (params) => darkPlateBackground(params);

export default dark;
